import { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useData } from '../../../contexts/DataContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiLock, FiMail, FiArrowRight, FiBriefcase, FiArrowLeft, FiHome, FiAlertCircle } = FiIcons;

const SellerLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { users, sellers } = useData(); // Henter også sellers-listen
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(false);

    const normalizedEmail = email.trim().toLowerCase();

    // 1. Sjekk først i app_users (Interne ansatte med rolle seller/sales_chief)
    let foundUser = users.find(u => 
      u.email?.trim().toLowerCase() === normalizedEmail && 
      u.password === password
    );

    // 2. Hvis ikke funnet der, sjekk sellers-tabellen (Rene selgere)
    if (!foundUser) {
       const foundSeller = sellers.find(s => 
         s.email?.trim().toLowerCase() === normalizedEmail && 
         typeof s.password === 'string' &&
         s.password.length > 0 &&
         s.password === password &&
         s.active !== false
       );
       
       if (foundSeller) {
         // Normaliser til et brukerobjekt som AuthContext forstår
         foundUser = {
           ...foundSeller,
           role: 'seller',
           id: foundSeller.id,
           sellerId: foundSeller.seller_id || foundSeller.sellerId || foundSeller.id
         };
       }
    }

    const validRoles = ['seller', 'sales_chief', 'team_leader'];

    if (foundUser && validRoles.includes(foundUser.role)) {
      await login(foundUser, foundUser.role);
      navigate('/seller/dashboard');
    } else {
      setError('Ugyldig e-post eller passord for selger-tilgang.');
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white rounded-3xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
              <SafeIcon icon={FiBriefcase} className="text-3xl text-white" />
            </div>
            <h1 className="text-2xl font-black text-gray-900">Selgerportal</h1>
            <p className="text-gray-500 mt-1">Logg inn for å se dine leads og salg</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {error && (
              <div className="bg-red-50 text-red-600 p-4 rounded-xl text-sm font-bold border border-red-100 flex items-center gap-2">
                <SafeIcon icon={FiAlertCircle} /> {error}
              </div>
            )}
            <div>
              <label className="text-[10px] font-black uppercase text-gray-400 ml-1 mb-1 block">E-post</label>
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)} className="w-full p-4 bg-gray-50 border-none rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none" placeholder="din@epost.no" />
            </div>
            <div>
              <label className="text-[10px] font-black uppercase text-gray-400 ml-1 mb-1 block">Passord</label>
              <input type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full p-4 bg-gray-50 border-none rounded-2xl focus:ring-2 focus:ring-blue-500 outline-none" placeholder="••••••••" />
            </div>
            <button type="submit" className="w-full bg-blue-600 text-white py-4 rounded-2xl font-black text-lg hover:bg-blue-700 transition-all shadow-xl flex items-center justify-center gap-2">
              Logg inn <SafeIcon icon={FiArrowRight} />
            </button>
          </form>

          <div className="mt-8 pt-6 border-t flex flex-col gap-3">
             <button onClick={() => navigate('/')} className="text-gray-400 hover:text-gray-600 text-sm font-bold flex items-center justify-center gap-2">
               <SafeIcon icon={FiHome} /> Tilbake til forsiden
             </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default SellerLogin;
